<template>
  <header id="header">
    <div class="hd-fixed">
      <div class="hd">
        <router-link :to="$lp('/')" class="logo">
          <img src="../assets/logo/hope_36x50@2x.png" alt="Hope" width="26">
          <span>
            <small>{{ clinic.corp }}</small>
            <strong>{{ $lang === 'ja' ? 'のぞみクリニック' + clinicName : clinic.name }}</strong>
          </span>
        </router-link>

        <nav class="gn">
          <div class="dd" :class="{ open: megaOpen }" @mouseenter="megaOpen = true" @mouseleave="megaOpen = false">
            <button type="button" @click="megaOpen = !megaOpen">{{ $t('nav.menu') }}</button>
            <div class="mega">
              <div class="col">
                <h5>{{ $t('nav.insured') }}</h5>
                <router-link v-for="d in insured" :key="d.key" :to="$lp(d.path)">
                  <span class="ic">{{ d.icon }}</span>
                  <span>{{ d.name }}<small>{{ d.target }}</small></span>
                </router-link>
              </div>
              <div class="col">
                <h5>{{ $t('nav.free') }}</h5>
                <router-link v-for="d in free" :key="d.key" :to="$lp(d.path)">
                  <span class="ic">{{ d.icon }}</span>
                  <span>{{ d.name }}<small>{{ d.target }}</small></span>
                </router-link>
              </div>
              <router-link class="all" :to="$lp({ path: '/', hash: '#menu' })">{{ $t('nav.all') }}</router-link>
            </div>
          </div>
          <router-link :to="$lp({ path: '/', hash: '#menu' })">{{ $t('nav.price') }}</router-link>
          <router-link :to="$lp('/about')">{{ $t('nav.about') }}</router-link>
          <router-link :to="$lp({ path: '/', hash: '#access' })">{{ $t('nav.access') }}</router-link>
          <router-link :to="$lp('/information')">{{ $t('nav.news') }}</router-link>
          <router-link :to="$lp('/sending')">{{ $t('nav.contact') }}</router-link>
        </nav>

        <div class="hd-r">
          <LangSwitch variant="inline"/>
          <a class="tel" :href="clinic.telHref">📞 {{ clinic.tel }}</a>
          <button class="rsv" type="button" @click="openBooking">{{ $t('btn.book') }}</button>
        </div>
      </div>
    </div>
    <div class="header_space"></div>
    <SiteNotice/>
  </header>
</template>

<script>
import { deptByPath } from '@/data/clinic'
import { L } from '@/data/localized'
import SiteNotice from '@/components/v6/SiteNotice'
import LangSwitch from '@/components/v6/LangSwitch'

export default {
  name: "PageHeader",
  components: { SiteNotice, LangSwitch },
  props: {
    clinicName: {
      default: '築地'
    },
    pathName: {
      default: 'tsukiji'
    }
  },
  data() {
    return { megaOpen: false }
  },
  computed: {
    clinic() { return L.clinic(this.$lang) },
    insured() { return L.depts(this.$lang).filter(d => !d.free) },
    free() { return L.depts(this.$lang).filter(d => d.free) },
  },
  watch: {
    $route() { this.megaOpen = false },
  },
  methods: {
    openBooking() {
      const d = deptByPath(this.$route.path)
      this.$store.commit('openBooking', d ? d.key : null)
    },
  },
}
</script>

<style scoped>
.hd-fixed{position:fixed;top:0;left:0;right:0;z-index:1024;background:#fff;border-bottom:1px solid var(--v6-bd);box-shadow:0 1px 6px rgba(0,0,0,.04)}
.header_space{height:65px}
.hd{max-width:1284px;margin:0 auto;height:64px;padding:0 20px;display:flex;align-items:center;justify-content:space-between;gap:16px;box-sizing:border-box}
.logo{display:flex;align-items:center;gap:10px;text-decoration:none;flex:none}
.logo small{display:block;font-size:11px;color:#9e9e9e;font-weight:700;line-height:1.2}
.logo strong{display:block;font-size:19px;color:var(--v6-brand);line-height:1.25;white-space:nowrap}
.gn{display:flex;align-items:center;gap:22px;height:100%;font-size:14.5px;font-weight:700}
.gn>a,.dd>button{color:var(--v6-ink);text-decoration:none;white-space:nowrap;transition:color .15s}
.gn>a:hover,.dd>button:hover,.gn>a.router-link-exact-active:not([href*="#"]){color:var(--v6-brand-d)}
.dd{position:relative;height:100%;display:flex;align-items:center}
.dd>button{background:none;border:none;cursor:pointer;font:inherit;font-weight:700;padding:0}
.dd>button::after{content:" ▾";font-size:10px;color:var(--v6-sub)}
.mega{position:absolute;top:100%;left:-24px;width:580px;background:#fff;border:1px solid var(--v6-bd);border-radius:0 0 12px 12px;box-shadow:0 12px 30px rgba(0,0,0,.1);padding:14px 16px;display:none;grid-template-columns:1fr 1fr;gap:4px 18px;font-weight:400}
.dd.open .mega{display:grid}
.col{display:flex;flex-direction:column}
.mega h5{font-size:11px;color:var(--v6-sub);letter-spacing:.08em;margin:4px 0 2px;border-bottom:1px solid var(--v6-bd);padding-bottom:4px}
.mega a{display:flex;gap:8px;align-items:center;padding:7px 6px;border-radius:6px;font-size:14px;color:var(--v6-ink);text-decoration:none}
.mega a:hover{background:var(--v6-brand-l)}
.mega .ic{font-size:20px;flex:none}
.mega small{display:block;font-size:11px;color:var(--v6-sub);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;max-width:220px}
.mega .all{grid-column:1/-1;justify-content:flex-end;font-size:12.5px;color:var(--v6-brand-d);border-top:1px solid var(--v6-bd);margin-top:4px;padding-top:8px}
.hd-r{display:flex;align-items:center;gap:8px;flex:none}
.tel,.rsv{display:inline-flex;align-items:center;justify-content:center;height:40px;padding:0 18px;border-radius:8px;font-size:15px;font-weight:700;white-space:nowrap;box-sizing:border-box;font-family:inherit;line-height:1}
.tel{color:var(--v6-brand-d);text-decoration:none;border:1.5px solid var(--v6-brand)}
.tel:hover{background:var(--v6-brand-l)}
.rsv{background:var(--v6-cta);color:#fff;border:1.5px solid var(--v6-cta);cursor:pointer;transition:background .15s}
.rsv:hover{background:var(--v6-cta-d)}
@media (max-width:1180px){
  .gn{gap:14px;font-size:13.5px}
  .tel{display:none}
}
@media (max-width:1060px){
  .logo small{display:none}
  .logo strong{font-size:17px}
  .hd{padding:0 14px}
}
</style>
